import { useIntl } from "react-intl";
import type { GeocodedPlace } from "src/GeocodedPlace";
import { Dialog } from "src/components/Dialog/Dialog";
import { CloseButton } from "src/auth/components/CloseButton/CloseButton";
import Search from "src/design-system/icons/Search.svg?react";
import { tw } from "src/design-system/tw";
import type { AutocompletePlace } from "../../../api/v1.6/autocomplete";
import messages from "../AddDestination/AddDestinationButton.messages";
import { AddDestinationInput } from "../AddDestination/AddDestinationInput";

type Props = {
  isOpen: boolean;
  onCloseClicked: () => void;
  onBackdropClicked: () => void;
  onSelectOption: (place: AutocompletePlace) => void;
  place?: GeocodedPlace;
  initialValue?: string;
};
export function EditPlaceDialog(props: Props) {
  const intl = useIntl();
  const title = props.place
    ? intl.formatMessage(messages.editPlacePrompt)
    : intl.formatMessage(messages.destinationPrompt);

  return (
    <Dialog
      isOpen={props.isOpen}
      variant="small"
      align="flex-start"
      topOffset="20%"
      onBackdropClicked={props.onBackdropClicked}
    >
      <div className="w-120 px-4 pt-3 pb-4">
        <h3 className="mb-3 text-heading-sm">{title}</h3>

        <div className="absolute top-2 right-3">
          <CloseButton onClick={props.onCloseClicked} />
        </div>

        <AddDestinationInput
          // We can disable this autoFocus rule because we only ever have one instance
          // in the DOM at any one time.
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          type="destination"
          id="add-destination-modal"
          AutocompleteListWrapper={AutocompleteListWrapper}
          icon={<Search className="h-5 w-5 text-icon-primary" />}
          solidBackground
          {...props}
        />
      </div>
    </Dialog>
  );
}

function AutocompleteListWrapper(props: React.ComponentProps<"div">) {
  return (
    <div
      {...props}
      className={tw("max-h-full overflow-y-auto", props.className)}
    >
      {props.children}
    </div>
  );
}
